/**
 * @generated SignedSource<<caf42d68c228543f44f66dbfe2fdc0e9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerReviewsModalHeader_reviews$data = {
  readonly totalResults: number | null;
  readonly " $fragmentType": "SellerReviewsModalHeader_reviews";
};
export type SellerReviewsModalHeader_reviews$key = {
  readonly " $data"?: SellerReviewsModalHeader_reviews$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerReviewsModalHeader_reviews">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerReviewsModalHeader_reviews",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    }
  ],
  "type": "OrderFeedbackMultipleQueryConnection",
  "abstractKey": null
};

(node as any).hash = "d6b775707b8aab32b9b83a943eecde5c";

export default node;
